'use strict';
module.exports = require('./Skeleton.vue');